export const getCustomSortSortOrderViewItems = (customSort) => {
    return {
        name: 'Sort Order',
        values: customSort.SortedValues,
    };
};
